module.exports = __webpack_public_path__ + "static/media/sign-in-background-2.f7f81bde.png";